export default __webpack_public_path__ + "static/wind-7c52c4b72e7d3aaf0df2e3dbd3711e8e.jpg";